import { Card, Col, Row, Spin } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import {
	validateExternalByMailToken,
	validateCompanyByMailToken,
} from "../../Requests/mail-validation-request";
import Text from "antd/lib/typography/Text";
import {
	mailValidationRequestConflict,
	mailValidationRequestFailedOther,
	mailValidationRequestSucceeded,
	mailValidationRequestUnauthorized,
	selectLoading,
	selectMessage,
} from "./MailValidationSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { theme } from "../../theme";
import CustomButton from "../../CustomComponents/CustomButton";
import { validateEmail } from "../../utils/reactQueriesConstants";
import Layout from "../../Containers/Layout";
import { getErrorFromResponse } from "../../utils/responseUtils";
import { ErrorCodes } from "../../Api";

const MailValidation = () => {
	const { t } = useTranslation();
	const { validationToken } = useParams<{ validationToken: string }>();
	const dispatch = useDispatch();
	const loading = useSelector(selectLoading);
	const message = useSelector(selectMessage);
	const search = useLocation().search;
	const type = new URLSearchParams(search).get("type") as any;

	useQuery(
		[validateEmail, type],
		() => {
			(type === "external"
				? validateExternalByMailToken
				: validateCompanyByMailToken)(validationToken)
				.then(() => {
					dispatch(mailValidationRequestSucceeded());
				})
				.catch(async (error) => {
					const errorMessage = await getErrorFromResponse(error);

					if (errorMessage?.code === ErrorCodes.ValidationTokenExpired) {
						dispatch(mailValidationRequestUnauthorized());
					} else if (
						errorMessage?.code === ErrorCodes.CompanyAlreadyActive ||
						errorMessage?.code === ErrorCodes.ExternalUserAlreadyActive
					) {
						dispatch(mailValidationRequestConflict());
					} else {
						dispatch(mailValidationRequestFailedOther());
					}
				});
		},
		{
			refetchOnWindowFocus: false,
		}
	);

	return (
		<Layout>
			<Card style={{ alignContent: "center", border: "none" }}>
				<Row style={{ alignContent: "center" }} justify={"center"}>
					<Col>
						<img
							alt="logo"
							src="/images/logo/text.svg"
							className="w-[90%] max-w-[420px]"
						/>
					</Col>
				</Row>
				<Row justify={"center"}>
					<Col>
						{loading && <Spin size="large" style={{ padding: 10 }} />}
						<Text style={{ verticalAlign: "middle", fontSize: "1.5rem" }}>
							{t(message)}
						</Text>
					</Col>
				</Row>
				<Row justify={"center"}>
					<Col>
						<CustomButton
							backgroundcolor={theme.primaryColor}
							textcolor={theme.white}
							paddingvertical={"1.5rem"}
							style={{
								fontSize: "1.3rem",
								width: "fit-content",
								overflowWrap: "break-word",
							}}
						>
							<Link to="/">{t("mailValidationText.redirect")}</Link>
						</CustomButton>
					</Col>
				</Row>
			</Card>
		</Layout>
	);
};

export default MailValidation;
